import { NeoState } from '../Reducers.interface';
import { ITrainer } from '~/Models/DTO/Trainer.models';
import { createSelector } from 'reselect';
import { keyBy } from 'lodash-es';

export const selectTrainerList = (state: NeoState): ITrainer[] => state.provider.trainers;
export const selectTrainersMap = createSelector(selectTrainerList, (trainers) =>
  keyBy(trainers, 'trainerId'),
);

export const selectActiveTrainerList = (state: NeoState) =>
  state.provider.trainers?.filter((trainer) => !trainer.archived) ?? [];

export const selectTrainerById = (trainerId: string) => (state: NeoState): ITrainer | undefined =>
  state.provider.trainers.find((item) => item.trainerId === trainerId);

export const selectTrainersById = (trainerIds: string[]) => (state: NeoState): ITrainer[] =>
  state.provider.trainers.filter((trainer) => trainerIds.includes(trainer.trainerId));
